export const formatDate = (
  iso: string,
  t: (key: string, options?: any) => string
) => {
  const now = new Date();
  const date = new Date(iso);
  const diffMs = now.getTime() - date.getTime();

  const MINUTE_MS = 60 * 1000;
  const HOUR_MS = 60 * MINUTE_MS;
  const DAY_MS = 24 * HOUR_MS;
  const MONTH_MS = 30 * DAY_MS;
  const YEAR_MS = 365 * DAY_MS;

  if (diffMs < MINUTE_MS) {
    return t("timestamp.now");
  } else if (diffMs < HOUR_MS) {
    const minutes = Math.floor(diffMs / MINUTE_MS);
    return t("timestamp.minute", { count: minutes });
  } else if (diffMs < DAY_MS) {
    const hours = Math.floor(diffMs / HOUR_MS);
    return t("timestamp.hour", { count: hours });
  } else if (diffMs < MONTH_MS) {
    const days = Math.floor(diffMs / DAY_MS);
    return t("timestamp.day", { count: days });
  } else if (diffMs < YEAR_MS) {
    const months = Math.floor(diffMs / MONTH_MS);
    return t("timestamp.month", { count: months });
  } else {
    const monthKey = `month.${date.getMonth()}`;
    const year = date.getFullYear() % 100;
    return t("timestamp.monthYear", {
      month: t(monthKey),
      year: year.toString().padStart(2, "0"),
    });
  }
};
